import { Button, Grid, Switch } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import { useAgencyInfo } from "context/agency";
import SoftButton from "components/SoftButton";
import env from "config";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { useUploadImage } from "hook/services";
import toast from "react-hot-toast";

function ProfileSettings({ loading, handelThemeData, selectedTheme }) {
  const inputData = selectedTheme?.theme_data?.general;
  const [agency,Update] = useAgencyInfo();
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const SERVER_IP = env.SERVER_IP;

  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);

  const url = inputData?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;

  const handleFieldBlur = async (e) => {
    const { name, value } = e.target;
    if (!name) return;

    if ((agency?.profile?.[name] || "") === value) return;

    const updatedProfile = { ...agency?.profile, [name]: value };
    const updatedGeneral = { ...selectedTheme?.theme_data?.general, [name]: value };

    try {
      const response = await handelThemeData({
        ...selectedTheme?.theme_data,
        general: updatedGeneral,
        profile: updatedProfile,
      });

      if (response) {
        Update({ profile: updatedProfile });
        toast.success(`${name.replace(/_/g, " ")} saved`);
      } else {
        toast.error(`Failed to save ${name.replace(/_/g, " ")}`);
      }
    } catch (error) {
      toast.error(`Failed to save ${name.replace(/_/g, " ")}`);
    }
  };

  return (
    <div>
      <SoftBox component="form" onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} className="zeroBtmP">
            <SoftTypography variant="h5">Customer Info</SoftTypography>
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Email"
              placeholder="example@email.com"
              inputProps={{ type: "email" }}
              name="email"
              defaultValue={agency?.profile?.email || "email@smartdirectory.ai"}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Name"
              placeholder="Enter Name"
              inputProps={{ type: "text" }}
              name="name"
              defaultValue={agency?.profile?.name || "Smart Directory"}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Phone Number"
              placeholder="(555) 123-4567"
              inputProps={{ type: "phone" }}
              name={"phone_number"}
              defaultValue={agency?.profile?.phone_number || "(555) 123-4567"}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="First Name"
              placeholder="First name"
              name="firstName"
              defaultValue={agency?.profile?.firstName || ""}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Last Name"
              placeholder="Last name"
              name="lastName"
              defaultValue={agency?.profile?.lastName || ""}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Alternate Email"
              placeholder="alternate@email.com"
              inputProps={{ type: "email" }}
              name="alternateEmail"
              defaultValue={agency?.profile?.alternateEmail || ""}
              onBlur={handleFieldBlur}
            />
          </Grid>

          <Grid item xs={12} className="zeroBtmP" style={{ marginTop: "20px" }}>
            <SoftTypography variant="h5">Social Links</SoftTypography>
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Facebook"
              placeholder="Facebook"
              name="facebook"
              defaultValue={agency?.profile?.facebook}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Instagram"
              placeholder="Instagram"
              name="instagram"
              defaultValue={agency?.profile?.instagram}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="LinkedIn"
              placeholder="LinkedIn"
              name="linkedin"
              defaultValue={agency?.profile?.linkedin}
              onBlur={handleFieldBlur}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Twitter"
              placeholder="Twitter"
              name="twitter"
              defaultValue={agency?.profile?.twitter}
              onBlur={handleFieldBlur}
            />
          </Grid>

          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Contact Us"
              placeholder="Contact Us"
              name="contact_us"
              defaultValue={agency?.profile?.contact_us}
              onBlur={handleFieldBlur}
            />
          </Grid>

          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Learn More"
              placeholder="Learn More"
              name="learn_more"
              defaultValue={agency?.profile?.learn_more}
              onBlur={handleFieldBlur}
            />
          </Grid>

          {openWhitelabelModal && (
            <div className="modal-zz-confirm" onClick={() => setopenWhitelabelModal(false)}>
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ border: "1px solid black ", position: "relative" }}
              >
                <h2 className="text-center font-14"> Connect white label domain</h2>
                <span className="crossison">X</span>
                <div className="list-model0">
                  <p>
                    Connect your own domain to the system (without https://)
                    maybetech.yourdomain.com
                  </p>
                  <p>
                    {" "}
                    You can use any domain you own or you can create a sub-domain like
                    maybetech.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className="listtext">
                      <b>1.</b> Refer to your domain registrar&apos;s control panel, choose desired
                      domain zone.
                    </li>

                    <li className="listtext">
                      {" "}
                      <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type, enter your domain/subdomain name and point it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u>{" "}
                    </li>
                    <li className="listtext">
                      {" "}
                      <b>3.</b> We will do the rest!{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Grid>
      </SoftBox>
    </div>
  );
}

export default ProfileSettings;
